/**
 * Departure Display Component for SearchBarInput
 * 
 * Displays the departure field above the arrival input when in merge mode.
 * Clicking on it allows the user to modify the departure.
 * Only used for arrival input type.
 * 
 * @module DepartureDisplay
 */

import { useCallback, type Dispatch, type SetStateAction } from "react";

interface DepartureDisplayProps {

    /** Departure input value */
    "departureInput": string;

    /** Reference to departure input element */
    "departureInputRef": React.RefObject<HTMLInputElement>;

    /** Setter for merge mode */
    "setIsMerge": Dispatch<SetStateAction<boolean>>;
}

/**
 * Departure Display Component
 * 
 * @param {DepartureDisplayProps} props - Component props
 * @returns {JSX.Element} Departure display component
 */
const DepartureDisplay: React.FC<DepartureDisplayProps> = ( {
    departureInput,
    departureInputRef,
    setIsMerge,
} ) => {
    const handleChangeDeparture = useCallback( () => {
        if ( departureInputRef.current != null ) {
            // setDepartureInput( "" );
            setTimeout( () => {
                departureInputRef.current?.focus();
            }, 0 );
            setIsMerge( false );
        }
    }, [ departureInputRef, setIsMerge ] );

    return (
        <div
            className="w-[calc(100%-160px)] flex h-9 cursor-pointer"
            onClick={handleChangeDeparture}
        >
            <div className="flex items-center justify-center text-center pt-2 gap-1 px-3 py-1 min-w-24 bg-opacity-60 backdrop-blur-sm bg-gray-500 expanded rounded-xl rounded-b-none transition-all duration-200">
                {/**
                <div className="flex items-center justify-center w-4 h-4">
                    <span className="text-sm">
                        <img
                            alt="departure icon"
                            className="w-[85%] invert"
                            src={DepartureIcon}
                        />
                    </span>
                </div>
                */}
                <div className="text-ionic-light flex-1 min-w-0 text-sm font-extrabold whitespace-nowrap tracking-wide overflow-hidden text-ellipsis">
                    {departureInput}
                </div>
            </div>
        </div>
    );
};

export default DepartureDisplay;

